export class UploadPricingBehaviour {
  constructor(controller) {
    this.controller = controller;
    this.left = undefined;
    this.right = undefined;
    this.sides = ['left', 'right']; // simple side order array
  }

  async init(swatchComponent) {
    if (swatchComponent.side) {
      this[swatchComponent.side] = swatchComponent;
    }
  }

  onUpdatePrice() {
    let fileNames = new Set();
    let art_upload_fee_item = this.controller.settings.art_upload_fee_item;

    for (let side of this.sides) {
      const comp = this[side];
      if (comp) {
        const $price = comp.$container.find('.price');
        const art = this.controller.state.custom_art[side];

        if (art && art.file_name) {
          art.charge = true;
          $price.text(`+ ${art_upload_fee_item.price.formatted_price}`);
        } else if (art) {
          art.charge = false;
          $price.text('');
        }
      }
    }
  }
}